// @ts-nocheck
/**
 * Lasirius High-Performance Commerce & Quick Cart Engine
 * 1. Synchronous Ajax Add-to-Cart with Canonical Shopify Events & Instant Drawer Opening
 * 2. Instant Navigation Engine: Predictive Hover/Touch Link Prefetching for 0ms Transitions
 */
(function () {
  'use strict';
  if (window._lasiriusQuickCartInit) return;
  window._lasiriusQuickCartInit = true;

  /* ==========================================================================
     1. AJAX ADD TO CART & THEME EVENT SYNCHRONIZATION
     ========================================================================== */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.lasirius-card__quick-form, .avize-product__form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const btn = form.querySelector('.lasirius-card__btn-add, .avize-product__submit, button[type="submit"]');
    if (!btn || btn.disabled) return;

    const originalContent = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Ekleniyor...</span>';
    btn.classList.add('is-loading');

    try {
      // 1. Prepare request with sections parameter for instant cart drawer morphing
      const formData = new FormData(form);
      const variantId = form.querySelector('input[name="id"]')?.value;
      formData.set('sections', 'cart-drawer-section');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      if (!res.ok) {
        let errorMsg = 'Ekleme Başarısız';
        try {
          const errData = await res.json();
          if (errData.description || errData.message) {
            errorMsg = errData.description || errData.message;
          }
        } catch (_) {}

        btn.innerHTML = `<span>${errorMsg}</span>`;
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');

        setTimeout(() => {
          btn.innerHTML = originalContent;
          btn.disabled = false;
          btn.classList.remove('is-error');
        }, 2200);
        return;
      }

      const addData = await res.json();

      // 2. Fetch fresh cart state in parallel for exact totals
      let cartData = null;
      try {
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (cartRes.ok) {
          cartData = await cartRes.json();
        }
      } catch (_) {}

      const totalCount = cartData?.item_count ?? 1;
      const cartItems = cartData?.items ?? [addData];

      // 3. Dispatch Canonical Shopify Events for all theme components
      const deferredPromise = Promise.resolve({
        cart: {
          totalQuantity: totalCount,
          items: cartItems
        },
        detail: {
          items: cartItems,
          sections: addData.sections || {},
          itemCount: totalCount,
          didError: false,
          source: 'lasirius-quick-cart'
        }
      });

      const cartLinesEvent = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        cancelable: true,
        detail: {
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferredPromise
        }
      });
      cartLinesEvent.promise = deferredPromise;
      cartLinesEvent.action = 'add';
      document.dispatchEvent(cartLinesEvent);

      // Legacy/Custom fallback events for other third-party apps
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true }));
      } catch (_) {}

      // 4. Update Header Cart Bubble (Immediate Real-Time DOM Update)
      try {
        const countEls = document.querySelectorAll('cart-icon [ref="cartBubbleCount"], .cart-bubble__text-count, [data-testid="cart-bubble"]');
        countEls.forEach((el) => {
          el.textContent = totalCount < 100 ? String(totalCount) : '99+';
          el.classList.remove('hidden');
        });

        const bubbleEls = document.querySelectorAll('cart-icon [ref="cartBubble"], .cart-bubble');
        bubbleEls.forEach((el) => {
          el.classList.remove('visually-hidden');
        });

        const cartIcons = document.querySelectorAll('cart-icon, .header-actions__cart-icon');
        cartIcons.forEach((el) => {
          el.classList.toggle('header-actions__cart-icon--has-cart', totalCount > 0);
        });
      } catch (_) {}

      // 5. Open Cart Drawer Immediately
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (window.Shopify?.actions?.openCart) {
        window.Shopify.actions.openCart();
      }

      // 6. Visual Success Feedback on Button
      btn.innerHTML = '<span>✓ Eklendi</span>';
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');

      setTimeout(() => {
        btn.innerHTML = originalContent;
        btn.disabled = false;
        btn.classList.remove('is-success');
      }, 1800);

    } catch (err) {
      console.warn('[lasirius-quick-cart] Ajax add error:', err);
      btn.innerHTML = '<span>Bağlantı Hatası</span>';
      btn.classList.remove('is-loading');
      setTimeout(() => {
        btn.innerHTML = originalContent;
        btn.disabled = false;
      }, 2000);
    }
  });

  /* ==========================================================================
     2. BACK-FORWARD CACHE (BFCACHE) & FRESHNESS ASSURANCE
     - When navigating back/forward, mobile browsers can restore stale DOM snapshots
     - Detecting event.persisted ensures the page is cleanly revalidated from server
     ========================================================================== */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });
})();
